import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-spcod/spcodaccountdetail/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getPage = (current, size, params) => {
  return request({
    url: '/api/park-spcod/spcodaccountdetail/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/park-spcod/spcodaccountdetail/detail',
    method: 'get',
    params: {
      id
    }
  })
}


export const add = (row) => {
  return request({
    url: '/api/park-spcod/spcodaccountdetail/submit',
    method: 'post',
    data: row
  })
}

